import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendJob, BackendMutationExtractResourceTitleArgs } from 'src/types/backend';

const MUTATION = gql`
  mutation ExtractResourceTitle($customerId: ID!, $input: ResourceDetailsInput!) {
    extractResourceTitle(customerId: $customerId, input: $input) {
      id
      status
    }
  }
`;

type Variables = BackendMutationExtractResourceTitleArgs;
type Result = Pick<BackendJob, 'id' | 'status'>;

export const extractResourceTitle = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
